import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "relative flex flex-row justify-center w-full h-full text-center text-white",
  style: {"background-color":"#b3e9ff"}
}
const _hoisted_2 = {
  class: "relative flex flex-col",
  style: {"width":"60vmin"}
}
const _hoisted_3 = { class: "absolute w-full h-full flex flex-col flex-grow" }
const _hoisted_4 = { class: "relative flex flex-row justify-center items-center drop-shadow rounded-lg mt-40" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Your browser does not support HTML5 video. ")
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "absolute w-full h-full flex flex-col flex-grow justify-end pointer-events-none" }
const _hoisted_9 = { class: "relative text-black text-lg md:text-2xl font-bold p-6 rounded-full bg-white mb-24" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  class: "absolute -top-6 left-0 rounded-full p-3 text-center flex flex-col justify-center h-10",
  style: {"background-color":"#48b6ff"}
}
const _hoisted_12 = { class: "uppercase font-bold text-sm text-white" }
const _hoisted_13 = { class: "absolute bottom-5 z-20 right-6 rounded-full flex flex-row p-5 cursor-pointer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RecordButton = _resolveComponent("RecordButton")!
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Omar's lightbub placement for Word Focus mode "),
    _createCommentVNode("div class=\"absolute top-6 left-12\">\n      <div class=\"relative flex flex-row items-center\">\n        <div class=\"rounded-l-full p-3 text-center flex flex-col justify-center h-12 -m-6 -mt-4 pl-6 pr-8\" style=\"background-color: #48b6ff\">\n          <p class=\"uppercase font-bold\">{{ t('letsDiscuss') }}</p>\n        </div>\n        <img :src=\"omarChat\" class=\"z-10 w-16\" alt=\"Discussion Time icon\" />\n      </div>\n    </div"),
    _createCommentVNode(" Movie and record button "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.question.video)
            ? (_openBlock(), _createElementBlock("video", {
                key: 0,
                ref: "videoPlayer",
                class: "drop-shadow rounded-lg",
                preload: "true",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePlayPause()))
              }, [
                _createElementVNode("source", {
                  src: `${_ctx.question.video + '#'}t=0.001`,
                  type: "video/mp4"
                }, null, 8 /* PROPS */, _hoisted_5),
                _hoisted_6
              ], 512 /* NEED_PATCH */))
            : _createCommentVNode("v-if", true),
          (!_ctx.videoIsPlaying && _ctx.question.video && _ctx.mode !== _ctx.MODES.finalDiscussion)
            ? (_openBlock(), _createBlock(_component_RecordButton, {
                key: 1,
                class: "absolute",
                transparent: true,
                "recording-exists": true,
                onVclick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.togglePlayPause()))
              }))
            : _createCommentVNode("v-if", true),
          (_ctx.question.image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                src: _ctx.question.image,
                class: "drop-shadow rounded-lg"
              }, null, 8 /* PROPS */, _hoisted_7))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createCommentVNode(" eslint-disable-next-line vue/no-v-html "),
          (_ctx.boxText)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                innerHTML: _ctx.boxText
              }, null, 8 /* PROPS */, _hoisted_10))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.t('discussion')), 1 /* TEXT */)
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Quizz results and Omar's statement "),
    _createCommentVNode("template v-if=\"mode === MODES.quizzResults\">\n      <div class=\"relative flex flex-col justify-center\" style=\"width: 60vmin\">\n        <div class=\"py-4 my-8 w-full flex flex-col\">\n          <div class=\"relative text-black text-lg md:text-2xl font-bold p-6 rounded-full bg-white mb-24\">\n            <p v-html=\"question.mening[round].omarStatement\"></p>\n            <div class=\"absolute -top-6 left-0 rounded-full p-3 text-center flex flex-col justify-center h-10\" style=\"background-color: #48b6ff\">\n              <p class=\"uppercase font-bold text-sm text-white\">{{ t('discussion') }}</p>\n            </div>\n          </div>\n        </div>\n        <div class=\"relative flex flex-row justify-center items-center drop-shadow rounded-lg mt-3\">\n          <img :src=\"no\" alt=\"thumbs up image\" class=\"w-24 p-4\" />\n          <div class=\"border-gray-600 flex flex-row w-128 mx-1 rounded-full overflow-hidden\">\n            <div\n              v-if=\"totalResults - totalThumbsUp > 0\"\n              class=\"bg-red-600 h-24 flex flex-row\"\n              :style=\"{\n                width: ((totalResults - totalThumbsUp) / totalResults) * 100 + '%',\n                backgroundColor: '#ff3f14',\n              }\"\n            ></div>\n            <div\n              v-if=\"totalThumbsUp > 0\"\n              class=\"h-24 flex flex-row\"\n              :style=\"{ width: (totalThumbsUp / totalResults) * 100 + '%', backgroundColor: '#42e05d' }\"\n            ></div>\n          </div>\n          <img :src=\"yes\" alt=\"thumbs up image\" class=\"w-24 p-4\" />\n        </div>\n      </div>\n    </template"),
    _createCommentVNode("template v-if=\"mode === MODES.finalDiscussion\">\n      <div class=\"relative flex flex-col\" style=\"width: 60vmin\">\n        <div class=\"absolute w-full h-full flex flex-col flex-grow justify-start pt-40\">\n          <div clas=\"relative flex flex-row justify-center\">\n            <div class=\"relative inline-block\">\n              <img class=\"w-56 h-56\" src=\"@/assets/omar/OMAR-GLAD.svg\" alt=\"instructions - happy omar image\" />\n              <Button class=\"absolute pointer-events-auto bg-white p-2 rounded-full top-3 right-3\" :childclass=\"'w-12 h-12'\" @click=\"playMening()\">\n                <img class=\"w-6 h-6\" src=\"@/assets/icons/svg/speaker.svg\" alt=\"close\" />\n              </Button>\n            </div>\n          </div>\n        </div>\n        <div class=\"absolute w-full h-full flex flex-col flex-grow justify-end\">\n          <div class=\"relative text-black text-lg md:text-2xl font-bold p-6 rounded-full bg-white mb-24\">\n            <p v-html=\"boxText\"></p>\n            <div class=\"absolute -top-6 left-0 rounded-full p-3 text-center flex flex-col justify-center h-10\" style=\"background-color: #48b6ff\">\n              <p class=\"uppercase font-bold text-sm text-white\">{{ t('discussion') }}</p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </template"),
    _createCommentVNode(" Avatars "),
    (_ctx.mode === _ctx.MODES.discussion || _ctx.mode === _ctx.MODES.finalDiscussion)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.players.length >= 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "absolute pointer-events-none bg-center bg-no-repeat top-16 left-20",
                style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.bgAvatar1 + ')' })
              }, [
                _createVNode(_component_Avatar, {
                  layout: _ctx.players[0].profile.avatar,
                  class: "w-44 h-44"
                }, null, 8 /* PROPS */, ["layout"])
              ], 4 /* STYLE */))
            : _createCommentVNode("v-if", true),
          (_ctx.players.length >= 3)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "absolute pointer-events-none bg-center bg-no-repeat bottom-64 left-20",
                style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.bgAvatar2 + ')' })
              }, [
                _createVNode(_component_Avatar, {
                  layout: _ctx.players[2].profile.avatar,
                  class: "w-44 h-44"
                }, null, 8 /* PROPS */, ["layout"])
              ], 4 /* STYLE */))
            : _createCommentVNode("v-if", true),
          (_ctx.players.length >= 4)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "absolute pointer-events-none bg-center bg-no-repeat top-16 right-20",
                style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.bgAvatar3 + ')' })
              }, [
                _createVNode(_component_Avatar, {
                  layout: _ctx.players[3].profile.avatar,
                  class: "w-44 h-44"
                }, null, 8 /* PROPS */, ["layout"])
              ], 4 /* STYLE */))
            : _createCommentVNode("v-if", true),
          (_ctx.players.length >= 2)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "absolute pointer-events-none bg-center bg-no-repeat bottom-64 right-28",
                style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.bgAvatar4 + ')' })
              }, [
                _createVNode(_component_Avatar, {
                  layout: _ctx.players[1].profile.avatar,
                  class: "w-44 h-44"
                }, null, 8 /* PROPS */, ["layout"])
              ], 4 /* STYLE */))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_13, [
      _renderSlot(_ctx.$slots, "default", { class: "pointer-events-none text-lg text-white capitalize" })
    ])
  ]))
}